
<div class="col-12-nav" id="reset-password">
    <div class="signin-header">
        <div class="container">
            <section class="logo center-block-wrap">
                <div class="logo-white"></div>
            </section>
        </div>
    </div>
    <br>
    <ngx-spinner bdColor="rgba(51,51,51,0.55)"
        size="medium"
        color="#fff"
        type="line-spin-clockwise-fade"
        [fullScreen]="false">
        <p class="loading">{{ 'general.loading' | translate }}...</p>
    </ngx-spinner>
    <div class="img-background">
        <div class="row">
            <div class="col-12 text-right">
                <a tabindex="0" id="en" class="btn btn-default border border-left-0 border-top-0 border-bottom-0 border-dark rounded-0" (click)="functionsService.useLanguage('en')">EN <span class="sr-only">Change language to English</span></a>
                <a tabindex="0" id="es" class="btn btn-default" (click)="functionsService.useLanguage('es')">ES <span class="sr-only">Cambiar idioma a español</span></a>
            </div>
        </div>
        <div id="resetPass" class="row justify-content-center">
            <div class="col-12 text-center mw-351">
                <h3>{{'profile.change_password' | translate}}</h3>
                <div class="col-12">
                    <br />
                    <form [formGroup]="resetPasswordForm" class="mw-351" (ngSubmit)="resetPassword()" name="form">
                        <div class="form form-group text-left w-100 mb-2">
                            <label for="newPassword" class="change-pass-label">{{'password.new_password' | translate}}<span class="error">*</span></label>
                            <input id="newPassword" type="password" required="required" formControlName="newPassword" class="form-control input-creds"
                                   [ngClass]="{ 'is-valid': newPassword['valid'], 'is-invalid': newPassword['invalid'] }" (click)="removeError()" />
                            <ng-container *ngIf="resetPasswordForm.get('newPassword').invalid && (resetPasswordForm.get('newPassword').touched) || formSubmitted">
                                <div *ngIf="resetPasswordForm.get('newPassword').hasError('required')"  class="text-danger align-left">
                                    {{'general.required_field' | translate}}
                                </div>
                                <div *ngIf="newPassword['errors']['pattern']" class="text-danger">
                                    {{'password.pass_pattern' | translate}}
                                </div>
                                <div *ngIf="newPassword['errors']['minlength']" class="text-danger">
                                    {{'password.pass_length' | translate}}
                                </div>
                            </ng-container>
                        </div>
                        <div class="form form-group w-100 text-left">
                            <label for="confirmPassword" class="change-pass-label">{{'password.confirm_pass' | translate}}<span class="error">*</span></label>
                            <input id="confirmPassword" type="password" formControlName="confirmPassword" class="form-control input-creds"
                                   [ngClass]="{ 'is-valid': confirmPassword['valid'] && !resetPasswordForm['errors'],
                                    'is-invalid': confirmPassword['invalid'] || ((confirmPassword['touched'] || formSubmitted) 
                                    && resetPasswordForm['errors']) }" (click)="removeError()"/>
                            <ng-container *ngIf="(resetPasswordForm.get('confirmPassword').touched) || formSubmitted">
                                <div *ngIf="resetPasswordForm.get('confirmPassword').invalid && (formSubmitted || resetPasswordForm.get('confirmPassword').touched || resetPasswordForm.get('confirmPassword').dirty)" 
                                      class="text-danger align-left">
                                    {{'general.required_field' | translate}}
                                </div>
                                <div *ngIf="((confirmPassword['touched'] || formSubmitted) && (resetPasswordForm['errors']&&resetPasswordForm['errors']['passwordsDontMatch'])) && resetPasswordForm.get('confirmPassword').value"
                                     class="text-danger">
                                    {{'password.pass_mismatch' | translate}}
                                </div>
                            </ng-container>
                        </div>
                        <div class="form form-group mt-2 w-100">
                            <input type="submit" class="btn btn-alertia btn-green btn-h-green btn-dis-green btn-login" 
                                   title="{{'register.validate' | translate}}" value="{{'register.validate' | translate}}">
                            <div class="mt-2">
                                <a href="/login" class="custom-hyperlink" title="{{'general.back_to_login' | translate}}"><u>{{ 'general.back_to_login' | translate}}</u></a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
